// extracted by mini-css-extract-plugin
export default {"container":"TrialNotification_container__rKIgs","billingAdded":"TrialNotification_billingAdded__4xkml","text":"TrialNotification_text__UNB5X","link":"TrialNotification_link__1GlpQ"};